( function() {
  function onClickToggle(e) {
    const btn = e.currentTarget;
    const foot = btn.closest('.programme-footnote');
    if (!foot) return;
    const content = foot.querySelector('.footnote-content');
    const collapsed = foot.classList.toggle('is-collapsed');
    btn.setAttribute('aria-expanded', (!collapsed).toString());
    btn.textContent = collapsed ? 'Show notes' : 'Hide notes';
    if (content) {
      // optional: animate; simple hide/show is fine
    }
  }

  function init(root = document) {
    root.querySelectorAll('.programme-footnote .programme-footnote__toggle')
      .forEach((btn) => {
        // avoid double-binding
        if (!btn.dataset.bound) {
          btn.addEventListener('click', onClickToggle);
          btn.dataset.bound = '1';
        }
      });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
} )();
